{
    "back": "Kembali",
    "backHome": "Kembali ke Halaman Utama",
    "brand": "Kartu VNGGames",
    "buyMore": "Beli lebih banyak",
    "buyNow": "BELI SEKARANG",
    "buyWith": "Bayar dengan",
    "cannotGetVoucherInfo": "Tidak dapat mengambil informasi kartu Anda.",
    "cardName": "Nama",
    "cardPin": "PIN",
    "cards": "Kartu",
    "cardSerial": "Nomor Seri",
    "checkAgain": "Periksa lagi",
    "checkEmail": "Silakan periksa email Anda sebelum melakukan pembelian.",
    "checkOrderStatusAgainHint1": "Kami belum menerima informasi pembayaran untuk pesanan Anda.",
    "checkOrderStatusAgainHint2": "Silakan periksa dan verifikasi rincian pembayaran.",
    "checkOrderStatusHint": "Memeriksa hasil transaksi, silakan tunggu...",
    "checkout": "Checkout",
    "copied": "Tersalin!",
    "copyright": "Hak Cipta © 2023 VNG Corp. Hak cipta dilindungi undang-undang.",
    "date": "Tanggal",
    "discount": "Diskon",
    "discountNotIncluded": "(Tidak termasuk diskon)",
    "emptyCard": "Keranjang kosong! Silakan pilih kartu untuk melanjutkan.",
    "emptyOrder": "Tidak ada apa-apa di sini. Harap isi",
    "emptyProductionText": "Ups! Saat ini tidak ada produk yang cocok untuk Anda",
    "endSlogan": "semakin tinggi diskon yang bisa Anda dapatkan.",
    "errorPage": {
        "description": "Terjadi kesalahan yang tidak terduga sehingga kami tidak dapat menyelesaikan permintaan Anda.",
        "description2": "Silakan coba lagi.",
        "goBack": "Kembali",
        "title": "Internal Server Error!"
    },
    "errors": {
        "common": "Ups, terjadi kesalahan, silakan coba lagi nanti"
    },
    "evoucherName": "Nama Kartu",
    "found": "ditemukan",
    "gameInMarket": "Game yang menerima Kartu VNGGames",
    "onlyApplicableRegion": "Hanya wilayah yang berlaku dapat menggunakan Kartu VNGGames",
    "goBack": "Kembali",
    "goBackInTime": "Kembali dalam %{countdown} (detik)",
    "login": "Masuk",
    "loginHint": "Silakan masuk untuk melanjutkan",
    "logout": "Keluar",
    "membershipCard": "Kartu Keanggotaan",
    "name": "Nama",
    "notFound": {
        "goToHome": "Silakan ke halaman lain atau pergi ke Halaman Utama",
        "pageNotExist": "Halaman yang Anda cari tidak ditemukan.",
        "title": "Halaman tidak ditemukan!"
    },
    "notLoginHint": "Anda belum masuk.",
    "orderDate": "Tanggal Pemesanan",
    "orderId": "Order ID",
    "orderMinLimitHint": "Nilai pesanan tidak boleh kurang dari",
	"orderMaxLimitHint": "Nilai pesanan tidak boleh lebih dari",
    "paid": "Dibayar",
    "paymentFailed": "<b>Ups! Pembayaran Gagal</b>",
    "paymentFailedHint": "Pembayaran untuk Order ID <b>%{orderId}</b> tidak dapat diproses. <br/> Coba lagi.",
    "paymentHint": "Dengan mengklik BELI SEKARANG, Anda setuju bahwa transaksi ini TIDAK DAPAT DIKEMBALIKAN.",
    "paymentMethod": "Metode Pembayaran",
    "paymentStatus": "Status Pembayaran",
    "paymentSuccess": "Pembayaran berhasil",
    "paymentSuccessHint": "Detail pesanan dan pembayaran telah dikirimkan ke email Anda <b class='color-primary'>%{userEmail}</b>.",
    "pleaseCheck": "Silakan cek.",
    "price": "Harga",
    "purchaseHistory": "Pesanan Saya",
    "myCards": "Kartu Saya",
    "quantity": "Jumlah",
    "redirectToPaymentProviderHint": "Anda akan diarahkan ke situs mitra kami untuk pemrosesan pembayaran",
    "register": "Daftar",
    "results": "hasil",
    "retryAgain": "Coba lagi",
    "retryCheckOrder": "Saya sudah melakukan pembayaran, cek lagi.",
    "seeDetailVoucherList": "Lihat detail kartu Anda",
    "sentCardToMail": "Detail pesanan dan pembayaran akan dikirimkan ke email Anda",
    "showCards": "Tampilkan kartu",
    "startSlogan": "Semakin banyak yang Anda beli",
    "status": "Status",
    "subTotal": "Subtotal",
    "supportCenter": "Support Center",
    "titleCardSelling": "Situs penjualan kartu game terpercaya VNGGames",
    "total": "Total",
    "transactionId": "ID Transaksi:",
    "tryAgain": "Coba lagi",
    "yourOrder": "Keranjang Anda",
    "logoutLoadingHint": "Keluar...",
    "loginLoadingHint": "Masuk...",
    "myProfile": "Profil Saya",
    "buyCards": "Beli Kartu",
    "termsOfSale": "Ketentuan Penjualan",
    "termsOfUse": "Ketentuan Penggunaan",
    "privacyPolicy": "Kebijakan Privasi",
    "userGuide": {
        "title": "Panduan Pengguna",
        "chap1": "I. Kartu VNGGames",
        "viewProductsListTitle": "1. Lihat daftar produk",
        "registerTitle": "2. Daftar",
        "loginTitle": "3. Gabung",
        "buyCardTitle": "4. Beli Kartu VNGGames",
        "orderHistoyTitle": "5. Riwayat Pesanan",
        "cardManagementTitle": "6. Manajemen Kartu",
        "chap2": "II. Tebus di toko VNGGames",
        "accessVGC": "Langkah 1: Akses Kartu VNGGames",
        "clickBuyNow": "Langkah 2: Klik tombol 'BELI SEKARANG' atau Beli Kartu",
        "clickUserIconStep1": "Langkah 1: Klik ikon pengguna.",
        "clickUserIconStep2": "Langkah 2: Klik ikon pengguna.",
        "clickCreateAccount": "Langkah 2: Klik 'Buat akun VNGGames ' untuk membuat akun VNGGames.",
        "step3": "Langkah 3:",
        "step3EnterRegisteredEmail": "Masukkan email valid yang belum pernah digunakan sebelumnya untuk mendaftar di Kartu VNGGames",
        "step3AgreePrivacyPolicy": "Pilih \"Saya setuju dengan kebijakan privasi\"",
        "step3ClickContinue": "Klik tombol Lanjut",
        "note": "Catatan:",
        "clickToReadPrivacyPolicy": "Pengguna dapat mengklik \"privasi\" untuk membaca info sebelum memilih \"Saya setuju dengan kebijakan privasi\"",
        "displayExistedEmail": "Jika pengguna menggunakan email yang sudah ada, setelah mengklik tombol 'Lanjut', pesan \"Emailnya ada\" akan ditampilkan.",
        "enterValidPasswordRegister": "Langkah 4: Masukkan kata sandi yang valid dan klik tombol 'Lanjut'",
        "enterActivationCode": "Langkah 5: Masukkan kode aktivasi yang dikirimkan ke email Anda dan klik tombol 'Lanjut'.",
        "activationCodeTimeout": "Kode Aktivasi hanya berlaku selama 60 detik.",
        "resendActivationCode": "Jika Anda tidak menerima kode verifikasi atau kode kedaluwarsa, Anda dapat mengklik 'Kirim ulang kode'.",
        "enterPersonalInfo": "Langkah 6: Masukkan informasi pribadi Anda di formulir berikut dan klik tombol 'Lanjut'.",
        "completeRegistration": "Langkah 7: Klik tombol 'Lanjut' untuk menyelesaikan pembuatan akun VNGGames Anda dan mengakses Kartu VNGGames.",
        "redirectToBuyCard": "Langkah 8: Setelah berhasil membuat akun VNGGames , pengguna akan dialihkan ke halaman beli kartu.",
        "enterRegisteredEmail": "Langkah 3: Masukkan Email terdaftar Anda dan klik tombol 'Lanjut'.",
        "enterValidPasswordLogin": "Langkah 4: Masukkan kata sandi yang valid dan klik tombol 'Lanjut'. Pengguna akan dialihkan ke halaman beli kartu.",
        "retypeEmail": "Jika pengguna ingin memasukkan ulang email, mereka dapat mengklik tombol 'Masukkan email lagi'.",
        "recoverPassword": "Jika pengguna tidak ingat kata sandinya, mereka dapat mengklik 'Pulihkan Password' untuk mengambilnya kembali.",
        "selectMarket": "Langkah 1: Pilih pasar tempat pengguna ingin membeli kartu.",
        "selectQuantity": "Langkah 2: Pilih jumlah kartu yang ingin Anda beli.",
        "cardLimitation": "Pengguna dapat memilih banyak kartu, dengan jumlah maksimum 99 kartu per jenis, dalam batas nilai yang diperbolehkan.",
        "limitationRangeHighlight": "Jika nilai pesanan kurang dari atau lebih besar dari batas nilai yang diperbolehkan, pemberitahuan batas minimum/maksimum akan disorot dengan warna merah dan BELI SEKARANG akan dinonaktifkan.",
        "verifyCart": "Langkah 3: Verifikasi keranjang Anda, pilih metode pembayaran, dan klik tombol 'BELI SEKARANG' untuk melanjutkan pembayaran.",
        "readTermsOfSale": "Sebelum menekan tombol BELI SEKARANG, Anda harus membaca ketentuan penjualan kami dengan mengklik 'Ketentuan Penjualan '.",
        "partnerWebsite": "Langkah 4: Lanjutkan dengan pembayaran di situs web mitra.",
        "viewTransactionDetailsBuyCard": "Langkah 5: Lihat hasil transaksi atau klik Lihat detail kartu Anda.",
        "clickBuyMore": "Klik tombol BELI LEBIH BANYAK untuk melanjutkan pembelian kartu.",
        "clickBackToHome": "Klik ‘Kembali ke Halaman Utama’ untuk kembali ke halaman beranda.",
        "checkOrderAndPayment": "Langkah 6: Pengguna dapat mengecek info pemesanan dan pembayaran Kartu VNGGames dengan cara:",
        "checkOrderAndPaymentMethod1": "Metode 1: Periksa email yang diterima setelah pembelian kartu berhasil, dan klik halaman Pesan di dalam konten email.",
        "goToOrderPage": "Saat Anda mengklik ‘Order page’, Anda akan dialihkan ke halaman hasil pembayaran, dan Anda harus masuk dengan akun VGC yang benar yang Anda gunakan untuk membeli kartu sebelumnya.",
        "checkOrderAndPaymentMethod2": "Metode 2: Buka halaman Pesanan Saya dan periksa di bagian 5. Riwayat Pesanan.",
        "checkOrderAndPaymentMethod3": "Metode 3: Buka halaman Kartu Saya dan periksa di bagian 6. Manajemen Kartu.",
        "clickMyOrders": "Langkah 1: Klik tombol 'Pesanan Saya'.",
        "viewOrderHistory": "Langkah 2: Lihat riwayat pesanan.",
        "orderHistoryFilter": "Pengguna dapat memfilter riwayat pesanan mereka berdasarkan Tanggal, Status, Metode pembayaran",
        "clickOrderId": "Pengguna dapat mengklik ID Pesanan untuk melihat detailnya",
        "clickMyCardButton": "Langkah 1: Klik tombol 'Kartu Saya'.",
        "enterVerifyOTP": "Langkah 2: Masukkan OTP aktivasi yang dikirimkan ke email Anda dan klik tombol 'Lanjut'.",
        "myCardOTPTimeout": "OTP aktivasi hanya berlaku selama 5 menit.",
        "resendOTP": "Jika Anda tidak menerima verifikasi OTP atau OTP kedaluwarsa, Anda dapat mengklik 'Kirim Ulang OTP'.",
        "durationBetween2OTP": "Waktu antara setiap Kirim Ulang OTP adalah 60 detik.",
        "wrong3TimesARow": "Jika Anda salah memasukkan OTP lebih dari 3 kali berturut-turut dalam waktu 2 jam, verifikasi OTP Anda akan dikunci selama 10 menit.",
        "remainingResend": "Jika verifikasi OTP Anda terkunci selama 10 menit tetapi Anda masih dapat Mengirim Ulang OTP, setelah mengklik Kirim Ulang OTP, Anda masih dapat memasukkan OTP baru.",
        "resendOtp2TimeInHour": "Jika Anda meminta untuk mengirim OTP lebih dari 3 kali dalam 2 jam, fungsi Kirim Ulang OTP Anda akan dikunci selama 15 menit.",
        "redirectToMyCards": "Setelah berhasil memverifikasi OTP, pengguna akan dialihkan ke halaman detail Kartu Saya",
        "userCanSearchCardBy": "Langkah 3: Pengguna dapat mencari kartu dengan:",
        "enterInputField": "Masukkan Order ID atau Card name ke dalam kolom Order ID / Card name",
        "clickPurchaseDate": "Klik bidang Tanggal pembelian:",
        "selectFromToDate": "Pilih Dari tanggal - Hingga saat ini",
        "selectLastWeek": "Pilih Minggu lalu",
        "selectLastMonth": "Pilih Bulan lalu",
        "select3Months": "Pilih 3 bulan yang lalu",
        "clickCardStatus": "Klik bidang Status kartu:",
        "selectAll": "Pilih Semua",
        "selectSold": "Pilih Terjual",
        "selectAvailable": "Pilih Tersedia",
        "selectCardsToAction": "Langkah 4: Pilih setiap kartu satu per satu atau pilih semua kartu, lalu klik Tandai sebagai TERJUAL/Salin/Surel/Ekspor.",
        "markAsSold": "Tandai sebagai TERJUAL: Setelah menjual kartu, Anda dapat menandainya sebagai TERJUAL.",
        "copyCard": "Salin: Digunakan untuk menyalin informasi dari kartu yang dipilih.",
        "exportCard": "Ekspor: Digunakan untuk mengekspor kartu yang dipilih ke file PDF.",
        "emailCard": "Email: Digunakan untuk mengirim informasi kartu yang dipilih melalui email.",
        "sendToMe": "Pengguna dapat mengirim email ke diri mereka sendiri dengan memilih \"Kirim ke email saya\" dan kemudian mengklik tombol \"Kirim email\".",
        "sentToOther": "Pengguna dapat mengirim email ke orang lain dengan memilih \"Kirim ke email lain\", memasukkan alamat email penerima di kolom \"Enter email\", dan mengklik tombol \"Kirim email\".",
        "markAsSoldEmail": "Pengguna dapat mengklik \"Tandai semua kartu sebagai TERJUAL\" untuk menandai kartu sebagai TERJUAL setelah mengirimnya.",
        "emailSendLimitation": "Pengguna hanya dapat mengirim maksimal 10 email dalam jangka waktu 24 jam. Setelah 24 jam, batas pengiriman email akan diatur ulang.",
        "clickEmailHistoryToView": "Langkah 5: Klik \"Riwayat Email\" untuk meninjau email yang telah dikirim sebelumnya.",
        "processRedeem": "Setelah pengguna berhasil membeli kartu di VNGGames Card, pengguna dapat melanjutkan untuk menukarkan di toko VNGGames.",
        "accessVNGGamesShopAndLogin": "Langkah 1: Akses game toko VNGGames dan login",
        "indonesia": "Indonesia",
        "philiphines": "Filipina",
        "thailand": "Thailand",
        "malaysia": "Malaysia",
        "singapore": "Singapura",
        "marketLimitation": "Kartu yang dibeli di pasar mana pun diterapkan dengan benar ke toko VNGGames di pasar tersebut.",
        "selectVGCMethod": "Langkah 2: Pilih metode Kartu VNGGames.",
        "selectSuitablePackage": "Langkah 3: Pilih paket dengan harga tetap yang sesuai dengan nilai kartu yang dibeli di Kartu VNGGames.",
        "inputSerialAndPIN": "Langkah 4: Masukkan Nomor Seri + PIN yang valid.",
        "clickRedeemButton": "Langkah 5: Klik tombol 'Tukarkan'.",
        "viewTransactionAndCheckInGame": "Langkah 6: Lihat hasil transaksi dan cek ingame.",
        "lastModified": "Terakhir diubah: 24 Juli 2023"








	},
	"faq": {
		"title": "FAQ",
        "whatIsVNGGamesCard": "Apa itu Kartu VNGGames?",
        "benefits": "Benefit Top-up game dengan Kartu VNGGames",
        "whereToPurchase": "Di mana saya dapat membeli Kartu VNGGames?",
        "howToRedeem": "Bagaimana cara menukarkan game dengan Kartu VNGGames?",
        "errorWhenRedeem": "Error saat menukarkan game menggunakan Kartu VNGGames",
        "errorWhenPurchaseViaBank": "Error saat membeli Kartu VNGGames melalui Bank",
        "errorWhenPurchaseViaEWallet": "Kesalahan Pembayaran menggunakan E-wallet"
	},
    "regionLockedProductHint": "Kartu VNGGames hanya berlaku di negara masing-masing. Semua pembelian TIDAK DAPAT DIKEMBALIKAN. Harap pilih wilayah Anda dengan hati-hati sebelum membeli.",
    "chooseMarket": "Pilih negara",
    "successful": "Berhasil",
    "failed": "Gagal",
    "andMore": "dan lainnya",
    "tosAgreementHint": "Dengan mengklik BELI SEKARANG, Anda menyetujui",
    "all": "Semua",
	"duration": {
		"oneWeek": "1 Minggu yang lalu",
		"oneMonth": "1 Bulan yang lalu",
		"threeMonths": "3 Bulan yang lalu"
	},
	"selectPaymentMethodHint": "Pilih metode pembayaran Anda",
	"selectLanguageHint": "Pilih bahasa Anda",
	"links": "Tautan",
	"generatingCardHint": "Menghasilkan kartu, mohon tunggu...",
	"sessionTimeout": "Sesi Anda telah berakhir. Silakan login kembali.",
	"copy": "Salin",
    "menu": "Menu",
    "searchInputPlaceholder": "Cari berdasarkan ID Pesanan / Nama Kartu",
    "cardValue": "Nilai Kartu",
    "cardSelected": "%{totalCardSelected} kartu terpilih",
    "markAsSold": "Tandai %{totalCardSelected} sebagai TERJUAL",
    "markAsSoldShort": "Tandai sebagai TERJUAL",
    "email": "Surel",
    "export": "Ekspor",
    "to": "Ke",
    "startDate": "Tanggal mulai",
    "endDate": "Tanggal selesai",
    "lastWeek": "Minggu lalu",
    "lastMonth": "Bulan lalu",
    "last3Months": "3 bulan yang lalu",
    "purchased": "Dibeli",
    "purchasedDate": "Tanggal pembelian",
    "orderIdOrCardName": "ID Pesanan / Nama Kartu",
    "typeToSearch": "Ketik untuk mencari",
    "cardsCopiedSucessfully": "Kartu berhasil disalin!",
    "expires": "Kadaluarsa",
    "sold": "Terjual",
    "validUntil": "Berlaku hingga",
    "available": "Tersedia",
    "homepage": "Beranda",
    "error": "Terjadi kesalahan",
    "verifyOtp": {
        "title": "Periksa email Anda",
        "emailHint": "Kata Sandi Satu Kali (OTP) telah dikirim ke alamat email",
        "label": "Kata Sandi Satu Kali",
        "buttonVerify": "Verifikasi",
        "resendOtp": "Kirim Ulang OTP",
        "required": "Field ini wajib diisi",
        "invalid": "OTP tidak valid atau telah kedaluwarsa",
        "requestLimited": "Jumlah percobaan permintaan OTP melebihi batas yang ditentukan, akun terkunci sementara.",
        "validateLimited": "Jumlah percobaan verifikasi OTP melebihi batas yang ditentukan, akun terkunci sementara.",
        "resendHint": "Kami telah mengirimkan OTP baru ke alamat email Anda."
    },
    "cardInventory": {
        "markAsSoldHint": "Silakan pilih setidaknya satu kartu!",
        "markAsSoldSuccess": "Tandai sebagai terjual berhasil!",
        "twoFactorExpired": "Silakan verifikasi identitas Anda karena sesi Anda telah kadaluarsa.",
        "copyCardHint": "Silakan pilih setidaknya satu kartu!",
        "copyCardSuccess": " Informasi kartu berhasil disalin!",
        "sendEmailHint": "Silakan pilih setidaknya satu kartu!",
        "exportFileHint": "Silakan pilih setidaknya satu kartu!",
        "exportFileSuccess": "Berhasil mengekspor file! Silakan periksa folder unduhan Anda.",
        "sendEmailTitle": "Kirim email",
        "sendToMyEmail": "Kirim ke email saya (%{userEmail})",
        "sendToOther": "Kirim ke email lain",
        "receiverEmail": "Email penerima",
        "markAllAsSold": "Tandai semua kartu sebagai TERJUAL",
        "sendEmailButton": "Kirim email",
        "sendMailSuccess": "Email berhasil terkirim!",
        "errorIsRequired": "Bidang ini harus diisi",
        "errorInvalidFormat": "Format email tidak valid",
        "cardStatusText": "Status kartu",
        "emailHistory": {
            "title": "Riwayat Email",
            "receiverEmail": "Email penerima",
            "sendingTime": "Waktu pengiriman",
            "emailStatus": "Status email",
            "successful": "Berhasil",
            "sending": "Sedang dikirim",
            "failed": "Gagal",
            "cardInformation": "Informasi Kartu",
            "emailLimitHint": "Kamu memiliki %{currentEmailAvailable} kali kesempatan untuk mengirim email",
            "until": "sampai",
            "overLimit": "Anda telah mengirim melebihi batas yang ditentukan.",
            "pleaseWait": "Harap tunggu sampai"



        }
    },
    "pagination": {
        "total": "Total",
        "pageSize": "/halaman",
        "goTo": "Pergi ke"

    },
    "changeDomainToast": {
        "part1": "Alamat website BARU",
        "part2": "shop.vnggames.com/card",
        "part3": "telah berubah sejak 15 Januari 2024"
    }
}
